// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Baloo+Bhaijaan|Ubuntu);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Ubuntu', sans-serif;
}

.body{
  background: #347571;
  margin: 0;
  padding: 0 10px;
}

.payment{
  background: #ecf8e5;
  max-width: 480px;
  margin: 80px auto;
  height: auto;
  padding: 35px;
  padding-top: 70px;
  border-radius: 5px;
  position: relative;
}

.payment h2{
  text-align: center;
  letter-spacing: 2px;
  margin-bottom: 40px;
  color: #347571;
}

.form-ppl .label{
  display: block;
  color: #555555;
  margin-bottom: 6px;
}

.input{
  padding: 13px 0px 13px 25px;
  width: 100%;
  text-align: center;
  border: 2px solid #ecf8e5;
  border-radius: 5px;
  letter-spacing: 1px;
  word-spacing: 3px;
  outline: none;
  font-size: 16px;
  color: #555555;
}

.card-grp{
  display: flex;
  justify-content: space-between;
}

.card-item{
  width: 48%;
}

.space{
  margin-bottom: 20px;
}

.icon-relative{
  position: relative;
}

.icon-relative .fas,
.icon-relative .far{
  position: absolute;
  bottom: 12px;
  left: 15px;
  font-size: 20px;
  color: #555555;
}

.btn-ppl{
  margin-top: 40px;
  background: #347571;
  padding: 12px;
  text-align: center;
  color: #ecf8e5;
  border-radius: 5px;
  cursor: pointer;
}


.payment-logo{
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 100px;
  background: #ecf8e5;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0,0,0,0.2);
  text-align: center;
  line-height: 85px;
}

.payment-logo:before{
  content: "";
  position: absolute;
  top: 5px;
  left: 5px;
  width: 90px;
  height: 90px;
  /* background: #347571; */
  border-radius: 50%;
}

.payment-logo p{
  position: relative;
  color: #ecf8e5;
  font-family: 'Baloo Bhaijaan', cursive;
  font-size: 58px;
}

.text-ppl{
    font-family: "Roboto", sans-serif;
    font-size: 22px;
    font-weight: 500;
    text-transform: uppercase;
}

.form-ppl{
    text-align: center;
    justify-content: center;
}

.logo-ppl{
    width: 60px;
}

.textbox-ppl{
    text-align: left;
    padding: 2% 25%;
}

@media screen and (max-width: 420px){
  .card-grp{
    flex-direction: column;
  }
  .card-item{
    width: 100%;
    margin-bottom: 20px;
  }
  .btn{
    margin-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/payment/paypal.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sCAAsC;EACtC,eAAe;AACjB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Baloo+Bhaijaan|Ubuntu');\n\n*{\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Ubuntu', sans-serif;\n}\n\n.body{\n  background: #347571;\n  margin: 0;\n  padding: 0 10px;\n}\n\n.payment{\n  background: #ecf8e5;\n  max-width: 480px;\n  margin: 80px auto;\n  height: auto;\n  padding: 35px;\n  padding-top: 70px;\n  border-radius: 5px;\n  position: relative;\n}\n\n.payment h2{\n  text-align: center;\n  letter-spacing: 2px;\n  margin-bottom: 40px;\n  color: #347571;\n}\n\n.form-ppl .label{\n  display: block;\n  color: #555555;\n  margin-bottom: 6px;\n}\n\n.input{\n  padding: 13px 0px 13px 25px;\n  width: 100%;\n  text-align: center;\n  border: 2px solid #ecf8e5;\n  border-radius: 5px;\n  letter-spacing: 1px;\n  word-spacing: 3px;\n  outline: none;\n  font-size: 16px;\n  color: #555555;\n}\n\n.card-grp{\n  display: flex;\n  justify-content: space-between;\n}\n\n.card-item{\n  width: 48%;\n}\n\n.space{\n  margin-bottom: 20px;\n}\n\n.icon-relative{\n  position: relative;\n}\n\n.icon-relative .fas,\n.icon-relative .far{\n  position: absolute;\n  bottom: 12px;\n  left: 15px;\n  font-size: 20px;\n  color: #555555;\n}\n\n.btn-ppl{\n  margin-top: 40px;\n  background: #347571;\n  padding: 12px;\n  text-align: center;\n  color: #ecf8e5;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n\n.payment-logo{\n  position: absolute;\n  top: -50px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100px;\n  height: 100px;\n  background: #ecf8e5;\n  border-radius: 50%;\n  box-shadow: 0 0 5px rgba(0,0,0,0.2);\n  text-align: center;\n  line-height: 85px;\n}\n\n.payment-logo:before{\n  content: \"\";\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  width: 90px;\n  height: 90px;\n  /* background: #347571; */\n  border-radius: 50%;\n}\n\n.payment-logo p{\n  position: relative;\n  color: #ecf8e5;\n  font-family: 'Baloo Bhaijaan', cursive;\n  font-size: 58px;\n}\n\n.text-ppl{\n    font-family: \"Roboto\", sans-serif;\n    font-size: 22px;\n    font-weight: 500;\n    text-transform: uppercase;\n}\n\n.form-ppl{\n    text-align: center;\n    justify-content: center;\n}\n\n.logo-ppl{\n    width: 60px;\n}\n\n.textbox-ppl{\n    text-align: left;\n    padding: 2% 25%;\n}\n\n@media screen and (max-width: 420px){\n  .card-grp{\n    flex-direction: column;\n  }\n  .card-item{\n    width: 100%;\n    margin-bottom: 20px;\n  }\n  .btn{\n    margin-top: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
